import { observer } from "mobx-react";
import useStore from "../../../store";
import { useEffect } from "react";
import PageHeader from '../../../component/PageHeader';
import { Form, Input } from 'antd';
import ListComponent from "./Component/ListComponent";
import { CustomerBreadcrumb } from "../../../config/BreadcrumbConfig";

const Customers = observer(() => {
	const { CUSTOMER } = useStore();


	const onSearch = (text) => {
		if (text.length >= 3 || text.length === 0) {
			CUSTOMER.searchValue = text;
			CUSTOMER.setupGrid(CUSTOMER.agGrid);
		}
	};

	useEffect(() => {
		return () => {
			CUSTOMER.searchValue = '';
		};
	}, []);
	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={CustomerBreadcrumb.title}
				extra={[
					<Form.Item help={'Write 3 letters to search'} key={1}>
						<Input
							placeholder="Search here"
							onChange={(e) => onSearch(e.target.value)}
						/>
					</Form.Item>
				]}
			/>
			<ListComponent/>
		</div>
	);
});

export default Customers;